import React, { useRef, useState, useEffect } from "react";
import "./Question.css";
import { useInView } from "./useInview";
import { useModal } from "../../../context/modalContext"; // adjust path if needed

const maxChar = 250;

const cleanText = (text = "") =>
    text.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ");

const QuestionModalContent = ({ question, onClose }) => {
    const voiceRef = useRef(null);
    const [speed, setSpeed] = useState(1);

    const cleanQuestion = cleanText(question?.question || "");
    const cleanAnswer = cleanText(question?.answer || "").replace(/\n/g, "<br/>");

    const toggleSpeed = () => {
        const newSpeed = speed === 1 ? 1.5 : speed === 1.5 ? 2 : 1;
        setSpeed(newSpeed);

        if (voiceRef.current) {
            voiceRef.current.playbackRate = newSpeed;
        }
    };

    return (
        <div className="Question Question__selected">
            <div className="Question__container">

                <div className="Question__header">
                    <div className="Question__voice">
                        <div className="Question__voice--file">
                            <div className="Question__voice--container">
                                <div className="Question__title">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: cleanQuestion,
                                        }}
                                    />
                                </div>

                                {question?.voiceLink && (
                                    <>
                                        <audio
                                            controlsList="nodownload noplaybackrate"
                                            ref={voiceRef}
                                            controls
                                        >
                                            <source
                                                src={question.voiceLink}
                                                type="audio/mpeg"
                                            />
                                        </audio>

                                        <button
                                            onClick={toggleSpeed}
                                            className="Question__speedBtn"
                                        >
                                            {speed}x
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Question__answer">
                    <div
                        dir="rtl"
                        className="hebrew-text"
                        dangerouslySetInnerHTML={{ __html: cleanAnswer }}
                    />
                </div>
            </div>
        </div>
    );
};

const Question = ({ q: question }) => {
    const voiceRef = useRef(null);
    const containerRef = useRef(null);
    const { openModal, closeModal } = useModal();

    const inView = useInView(containerRef, { rootMargin: "400px" });
    const [shouldLoadAudio, setShouldLoadAudio] = useState(false);
    const [speed, setSpeed] = useState(1);

    useEffect(() => {
        if (inView && question?.voiceLink) {
            setShouldLoadAudio(true);
        }
    }, [inView, question?.voiceLink]);

    const toggleSpeed = () => {
        const newSpeed = speed === 1 ? 1.5 : speed === 1.5 ? 2 : 1;
        setSpeed(newSpeed);

        if (voiceRef.current) {
            voiceRef.current.playbackRate = newSpeed;
        }
    };

    const cleanQuestion = cleanText(question?.question || "");
    const cleanAnswer = cleanText(question?.answer || "");

    const previewText = cleanAnswer.slice(0, maxChar);

    const formattedAnswer = (
        `${previewText}${cleanAnswer.length > maxChar ? "..." : ""}`
    ).replace(/\n/g, "<br/>");

    const handleReadMore = () => {
        openModal(
            <QuestionModalContent
                question={question}
                onClose={closeModal}
            />
        );
    };

    return (
        <div ref={containerRef} className="Question">
            <div className="Question__container">
                <div className="Question__header">
                    <div className="Question__voice">
                        <div className="Question__voice--file">
                            <div className="Question__voice--container">
                                <div className="Question__title">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: cleanQuestion,
                                        }}
                                    />
                                </div>

                                {question?.voiceLink && (
                                    <>
                                        <audio
                                            controlsList="nodownload noplaybackrate"
                                            ref={voiceRef}
                                            controls
                                            preload="none"
                                        >
                                            {shouldLoadAudio ? (
                                                <source
                                                    src={question.voiceLink}
                                                    type="audio/mpeg"
                                                />
                                            ) : null}
                                        </audio>

                                        <button
                                            onClick={toggleSpeed}
                                            className="Question__speedBtn"
                                        >
                                            {speed}x
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Question__answer">
                    <div
                        dir="rtl"
                        className="hebrew-text"
                        dangerouslySetInnerHTML={{ __html: formattedAnswer }}
                    />

                    {cleanAnswer.length > maxChar && (
                        <button
                            className="Question__readMore"
                            onClick={handleReadMore}
                        >
                            للمزيد...
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Question;